import { LoaderFunction, useFetcher } from "react-router-dom";
import {
  redeemCodes,
  RedemptionList,
} from "../../../../common/api/decimal/methods/redeem.ts";
import { forceExploreRevalidation } from "../../../../common/api/bridge/methods.ts";

type isbn = string;
type RedemptionRecord =
  | { isOk: true; results: RedemptionList }
  | { isOk: false; error?: string; errorCode?: string };
type RedeemLoaderData = Record<isbn, RedemptionRecord>;

export const redeemCodesAction: LoaderFunction = async ({
  request,
}): Promise<RedeemLoaderData> => {
  const formData = await request.formData();
  const codes = Array.from(formData.entries())
    .filter(
      (entry) =>
        entry[0].startsWith("code") &&
        typeof entry[1] === "string" &&
        entry[1].trim().length
    )
    .map((entry) => (entry[1] as string).trim())
    .filter((code, i, codes) => codes.indexOf(code) === i);
  const results = await redeemCodes(codes);
  // Edge case of a redeem giving you explore content for the first time
  forceExploreRevalidation();
  return results.reduce<RedeemLoaderData>((acc, result, i) => {
    if (result.status === "fulfilled") {
      const value = result.value;
      acc[codes[i]] =
        value.ok && value.data
          ? { isOk: true, results: value.data }
          : { isOk: false, error: value.error, errorCode: value.errorCode };
    } else {
      acc[codes[i]] = { isOk: false };
    }
    return acc;
  }, {});
};

export function useRedeemFetcher() {
  return useFetcher<RedeemLoaderData>();
}
